import React, { useMemo } from 'react';

import { SiteConfigManager } from '@atlas/core';
import { BonusDetailsInfoMobileSkeleton, Icon, Label } from '@atlas/ui';

import useFormatter from 'src/hooks/useFormatter';

import {
  BONUS_COLUMN_IDS,
  BONUS_FREESPIN_INFO_COLUMNS,
  BONUS_INFO_COLUMNS,
  resolveVisibleColumns,
} from './bonusDetailColumns';
import { useBonusDetailContext } from './BonusDetailContext';
import { BONUS_KIND } from 'components/ClientProfile/Bonuses/BonusDetail/resolveBonusEntity';

const Skeleton = () => {
  return (
    <section className="panel">
      <BonusDetailsInfoMobileSkeleton />
    </section>
  );
};

const BonusDetailInfo = () => {
  const { entity, kind, loading } = useBonusDetailContext();
  const { currencyFormatter } = useFormatter(entity?.currency);
  const hideSportBonuses = SiteConfigManager.getConfig('config.config.general.hideSportBonuses');

  const infoColumns = kind === 'freespin' ? BONUS_FREESPIN_INFO_COLUMNS : BONUS_INFO_COLUMNS;

  const rows = useMemo(() => {
    const visibleColumns = resolveVisibleColumns(infoColumns, entity, currencyFormatter);

    if (hideSportBonuses && entity?.type === BONUS_KIND.SPORT) {
      return visibleColumns.filter(column => column.id !== BONUS_COLUMN_IDS.PRODUCT);
    }

    return visibleColumns;
  }, [hideSportBonuses, infoColumns, entity, currencyFormatter]);

  if (loading) return <Skeleton />;
  if (!rows.length) return null;

  return (
    <section className="bonus-details__info panel">
      <div className="bonus-details__info-header">
        <Icon className="bonus-details__info-icon" name="bonus-deposit-icon" />
        <Label className="bonus-details__info-title" message="bonus_info" />
      </div>

      <div className="bonus-details__info-table">
        {rows.map(({ content, header, id }) => (
          <div className="bonus-details__info-row" key={id}>
            <span className="bonus-details__info-cell bonus-details__info-cell--label">
              <Label message={header} />
            </span>
            <span className="bonus-details__info-cell bonus-details__info-cell--value">
              {content}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BonusDetailInfo;
